import { render } from "./LabPrint2Dtl.vue?vue&type=template&id=429a4d9a"
import script from "./LabPrint2Dtl.vue?vue&type=script&lang=js"
export * from "./LabPrint2Dtl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__